import Logo from "../Logo/Logo";
import "./Nav.css";
import menu from "../../assets/menu-svgrepo-com.svg";
import { useEffect, useState } from "react";
import Toast from "../Toast/Toast";
import { Link } from "react-router-dom";
import HowItWorksModal from "../../utils/modals/HowItWorksModal";

export default function Nav(props) {
  const [menuActive, setMenuActive] = useState(false);
  const [howShow, setHowShow] = useState(false);
  const [downloadDropdown, setDownloadDropdown] = useState(false);
  const [toasts, setToasts] = useState([]);

  const handleToggleToast = () => {
    const newToast = {
      id: Date.now(),
      header: "Quickplanners",
      body: "Sorry, this feature is coming soon!",
    };
    setToasts([...toasts, newToast]);
  };

  const handleRemoveToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  function toggleMenu() {
    console.log(menuActive);
    setMenuActive(!menuActive);
  }

  function closeMenu() {
    setMenuActive(false);
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuActive &&
        !event.target.closest(".mobile-nav") &&
        !event.target.closest(".menu")
      ) {
        setMenuActive(false);
      }
      
      if (
        downloadDropdown &&
        !event.target.closest(".dropdown-items")
      ) {
        setDownloadDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuActive, downloadDropdown]);

  return (
    <div className="nav-wrapper">
      <nav className="d-flex justify-content-between align-items-center nav">
        <Logo />

        <div className="nav-list">
          <ul className="d-flex align-items-center nav-items">
            {/* <li onClick={() => setHowShow(true)}>How it works</li> */}
            <li><a href="/get-vendors">Get Vendors</a></li>
            <li><a href="/get-venue">Get a Venue</a></li>
            <li><a href="/plan-for-me">Plan for Me</a></li>
            
            {/* <li onClick={handleToggleToast}> Resources</li> */}
            {/* <li 
              className="dropdown-items"
              onMouseEnter={() => setDownloadDropdown(true)}
              onMouseLeave={() => setDownloadDropdown(false)}
            >
              Download <img src="/arrow-down.svg" alt="dropdown icon" />
              <div className={`dropdown-menu ${downloadDropdown ? 'show' : ''}`}>
                <a href="#" onClick={handleToggleToast}>Client App (iOS)</a>
                <a href="#" onClick={handleToggleToast}>Client App (Android)</a>
                <a href="#" onClick={handleToggleToast}>Vendors App (iOS)</a>
                <a href="#" onClick={handleToggleToast}>Vendors App (Android)</a>
              </div>
            </li> */}
          </ul>
        </div>

        {/* <HowItWorksModal howShow={howShow} setHowShow={setHowShow} /> */}

        <div className="nav-buttons">
          <a href="/register-vendor">
            <button className="nav-vendor-btn">Register as a vendor</button>
          </a>
          {/* <a href="/event-details">
            <button className="nav-get-started-btn">Get started</button>
          </a> */}
        </div>
        <img src={menu} alt="menu" className="menu" onClick={toggleMenu} />

        <div className={`mobile-nav ${menuActive ? "show" : ""}`}>
          <ul className="d-flex align-items-center nav-items">
            {/* <li onClick={() => { setHowShow(true); closeMenu(); }}>How it works</li> */}
        <li><a href="/get-vendors">Get Vendors</a></li>
            <li><a href="/get-venue">Get a Venue</a></li>
            <li><a href="/plan-for-me">Plan for Me</a></li>
            {/* <li className="mobile-dropdown">
              <span>Download</span>
              <div className="mobile-dropdown-items">
                <a href="#" onClick={() => { handleToggleToast(); closeMenu(); }}>Client App (iOS)</a>
                <a href="#" onClick={() => { handleToggleToast(); closeMenu(); }}>Client App (Android)</a>
                <a href="#" onClick={() => { handleToggleToast(); closeMenu(); }}>Vendors App (iOS)</a>
                <a href="#" onClick={() => { handleToggleToast(); closeMenu(); }}>Vendors App (Android)</a>
              </div>
            </li> */}
          </ul>
          <div className="mobile-nav-buttons">
            <a href="/register-vendor">
              <button className="nav-vendor-btn mobile">Register as a vendor</button>
            </a>
            {/* <a href="/event-details">
              <button className="nav-get-started-btn mobile">Get started</button>
            </a> */}
          </div>

          <Toast toasts={toasts} removeToast={handleRemoveToast} />
        </div>
      </nav>
    </div>
  );
}
